export const PRE_BOOKING = 'preBooking';
export const LANDING = 'landing';
export const WITH_ORDER = 'withOrder';
export const WITHOUT_ORDER = 'withoutOrder';
